// extracted by mini-css-extract-plugin
export default {"cardList":"CardList_cardList__47MKV"};